var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    x: 8,
    y: 4,
    stroke: "#800080",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#800080",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M14 11h20v9H14z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 26,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 32,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 38,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 26,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 32,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 26,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 32,
    r: 2,
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 38,
    r: 2,
    fill: "#800080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.18855fba3370b7a7af4ccb8bb11edf1e.svg";
export { ForwardRef as ReactComponent };